import React, { useEffect, useState } from "react";
import {
  getPromocodes,
  addPromocodes,
  getPromoCodesAdmin,
  addPromoCodeAdmin,
} from "./api";
import "./Promocode.css";

export default function Promocode() {
  const [tableType, setTableType] = useState("fixed"); // "fixed" | "percent" переход между таблицами
  const [promocodes, setPromocodes] = useState([]);
  const [amount, setAmount] = useState(0);
  const [count, setCount] = useState(1);
  const [code, setCode] = useState("");
  const [percent, setPercent] = useState(0);
  const [expiresAt, setExpiresAt] = useState('')

  useEffect(() => {
    fetchPromocodes();
  }, [tableType]);

  const fetchPromocodes = async () => {
    if (tableType === "fixed") {
      const data = await getPromocodes();
      setPromocodes(data);
    } else {
      const data = await getPromoCodesAdmin();
      setPromocodes(data);
    }
  };

  const handleAddPromo = async () => {
    if (tableType === "fixed") {
      if (count <= 0 || amount <= 0) {
        alert("Введите корректные данные");
        return;
      }
      await addPromocodes(count, amount);
    } else {
      if (!code || percent <= 0 || percent > 100) {
        alert("Введите корректные данные для процентного промокода");
        return;
      }
      await addPromoCodeAdmin(code, Number(percent), expiresAt);

    }

    fetchPromocodes();
    resetForm();
    alert("Промокод(ы) добавлены!");
  };

  const resetForm = () => {
    setCount(1);
    setAmount(0);
    setCode("");
    setPercent(0);
  };

  return (
    <div className="table-container">
      <h2>Промокоды</h2>

      {/* Переключатель таблицы */}
      <div className="toggle-container">
        <label>
          <input
            type="radio"
            value="fixed"
            checked={tableType === "fixed"}
            onChange={() => setTableType("fixed")}
          />
          Обычные (фикс. сумма)
        </label>
        <label>
          <input
            type="radio"
            value="percent"
            checked={tableType === "percent"}
            onChange={() => setTableType("percent")}
          />
          Процентные (% скидка)
        </label>
      </div>

      {/* Форма добавления */}
      <div className="filter-container">
        {tableType === "fixed" ? (
          <>
            <label className="filter_label">
              Количество:
              <input
                type="number"
                value={count}
                onChange={(e) => setCount(Number(e.target.value))}
                placeholder="Количество"
              />
            </label>
            <label className="filter_label">
              Сумма:
              <input
                type="number"
                value={amount}
                onChange={(e) => setAmount(Number(e.target.value))}
                placeholder="Сумма"
              />
            </label>
          </>
        ) : (
          <>
            <label className="filter_label">
              Код:
              <input
                type="text"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                placeholder="Например: SALE20"
              />
            </label>
            <label className="filter_label">
              % скидки:
              <input
                type="number"
                value={percent}
                onChange={(e) => {
                  const val = e.target.value;
                  // Разрешаем только числа от 0 до 100 или пустую строку
                  if (val === "" || (/^\d+$/.test(val) && +val <= 100)) {
                    setPercent(val);
                  }
                }}
                placeholder="1–100"
              />
            </label>
            <label className="filter_label">
              Действует до:
              <input
                type="date"
                value={expiresAt}
                onChange={(e) => setExpiresAt(e.target.value)}
                placeholder="Дата окончания"
              />
            </label>
          </>
        )}
        <button onClick={handleAddPromo}>Добавить</button>
      </div>

      {/* Таблица */}
      <table className="users-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Код</th>
            {tableType === "fixed" ? <th>Статус</th> : null}
            <th>{tableType === "fixed" ? "Сумма" : "% скидки"}</th>
            <th>Действует до</th>
          </tr>
        </thead>
        <tbody>
          {promocodes.map((promo) => (
            <tr key={promo.id}>
              <td>{promo.id}</td>
              <td>{promo.code}</td>
              {tableType === "fixed" ? <td>{promo.status}</td> : null}
              <td>{tableType === "fixed" ? promo.amount : promo.percent + "%"}</td>
              <td>{promo.expires_at?.slice(0, 10)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
